export const trackClick = (name) => {
    if (window.gtag) {
        window.gtag("event", "click", {
            event_category: "landing",
            event_label: name,
        });
    }
};
